module.exports = __webpack_public_path__ + "fonts/sourcesansprosemibold.e43fc02d.woff";